module.exports = __webpack_public_path__ + "static/the-hovas-ee231544180e788b18f7b9d0bdf8a710.png";